'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { useFaqIsSearching, useFaqSearchStore } from './FaqSearchContext';
import FaqSearchResults from './FaqSearchResults';
export default function FaqGroupSectionWrapper(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const isSearching = useFaqIsSearching();
  const store = useFaqSearchStore();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Math.random().toString(36);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const idRef = useRef(t1);
  const [isOwner, setIsOwner] = useState(false);
  let t2;
  let t3;
  if ($[1] !== isSearching || $[2] !== store) {
    t2 = () => {
      if (!store) {
        return;
      }
      if (isSearching) {
        const claimed = store.claimResultsOwner(idRef.current);
        setIsOwner(claimed);
        return () => {
          store.releaseResultsOwner(idRef.current);
          setIsOwner(false);
        };
      } else {
        store.releaseResultsOwner(idRef.current);
        setIsOwner(false);
      }
    };
    t3 = [isSearching, store];
    $[1] = isSearching;
    $[2] = store;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!isSearching) {
    let t4;
    if ($[5] !== children) {
      t4 = <>{children}</>;
      $[5] = children;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (isOwner) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <FaqSearchResults />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== children) {
      t5 = <>{t4}<div className="hidden">{children}</div></>;
      $[8] = children;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t4;
  if ($[10] !== children) {
    t4 = <div className="hidden">{children}</div>;
    $[10] = children;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}